'use client';

import { useEffect, useRef } from 'react';

export const useTypeSequence = (targetString: string, callback: () => void) => {
  const bufferRef = useRef<string>('');

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      bufferRef.current += e.key;
      if (bufferRef.current.length > targetString.length) {
        bufferRef.current = bufferRef.current.slice(-targetString.length);
      }
      if (bufferRef.current.toLowerCase() === targetString.toLowerCase()) {
        callback();
        bufferRef.current = '';
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [targetString, callback]);
};
